import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TaxonomyScope } from '../../models/Crop';

type AttributeScopeKey = 'familyId' | 'genusId' | 'speciesId' | 'cultivarId';

const scopeNameMap: Record<AttributeScopeKey, TaxonomyScope> = {
  familyId: 'family',
  genusId: 'genus',
  speciesId: 'species',
  cultivarId: 'cultivar',
};

export const useTaxonomyScope = (selectedPath: string[]) => {
  const { t } = useTranslation('crops');
  return useMemo(() => {
    if (!selectedPath.length) return null;
    const normalizedValues = selectedPath.map((value) => String(value));
    let key: AttributeScopeKey | null = null;
    let id: string | null = null;

    switch (normalizedValues.length) {
      case 1:
        key = 'familyId';
        id = normalizedValues[0];
        break;
      case 2:
        key = 'genusId';
        id = normalizedValues[1];
        break;
      case 3:
        key = 'speciesId';
        id = normalizedValues[2];
        break;
      case 4:
        key = 'cultivarId';
        id = normalizedValues[3];
        break;
    }

    if (!key || !id) return null;

    const scope = scopeNameMap[key];
    const numericScopeId = Number(id);
    
    return {
      scope,
      scopeId: Number.isNaN(numericScopeId) ? id : numericScopeId,
      label: t(`scope.${scope}`),
    };
  }, [selectedPath, t]);
};
